module.exports = __webpack_public_path__ + "img/dodFilterIcon.2b8da614.svg";